import { AVERAGE_HUMAN_SPEED, AVERAGE_CAR_SPEED } from '../consts';

export function getHowLongMinutesToAirport(distanceToAirport: number | null | undefined): number | null {
    if (!distanceToAirport) {
        return null;
    }

    return Math.round(distanceToAirport / AVERAGE_CAR_SPEED);
}

export function getHowLongMinutesToCenterCity(distanceToCenterCity: number | null | undefined): number | null {
    if (!distanceToCenterCity) {
        return null;
    }

    return Math.round((distanceToCenterCity / AVERAGE_HUMAN_SPEED) * 60);
}
